import { render, staticRenderFns } from "./pira.vue?vue&type=template&id=3aa5dc33&"
import script from "./pira.vue?vue&type=script&lang=js&"
export * from "./pira.vue?vue&type=script&lang=js&"
import style0 from "./pira.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports